import { create } from 'zustand';

interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

interface ConfirmState {
  isOpen: boolean;
  options: ConfirmOptions | null;
  resolve: ((value: boolean) => void) | null;
  confirm: (options: ConfirmOptions) => Promise<boolean>;
  onConfirm: () => void;
  onCancel: () => void;
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  isOpen: false,
  options: null,
  resolve: null,
  confirm: (options) => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        options,
        resolve,
      });
    });
  },
  onConfirm: () => {
    const resolve = get().resolve;
    if (resolve) resolve(true);
    set({ isOpen: false, options: null, resolve: null });
  },
  onCancel: () => {
    const resolve = get().resolve;
    if (resolve) resolve(false);
    set({ isOpen: false, options: null, resolve: null });
  },
}));
